export enum CommentHistoryActions {
  Resolved = 'Resolved',
  Reopened = 'Reopened',
  Added = 'Added',
  Edited = 'Edited',
  Replied = 'Replied',
}
